module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "headerTitle"
  }), _vm._v(" "), _c('div', {
    staticClass: "days"
  }, _vm._l((_vm.daysInMonth), function(i) {
    return _c('div', [_c('strong', {
      class: {
        isToday: _vm.isToday(i)
      }
    }, [_vm._v("\n                " + _vm._s(_vm.day(i)) + "\n            ")])])
  }), 0)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-54e3a1a4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/calendar/HeaderBlock.vue
// module id = 395
// module chunks = 1